import type { ExploreContentItemContentOneOfEngagementAllOf } from './exploreContentItemContentOneOfEngagementAllOf';
import type { ExploreContentItemContentOneOfEngagementAllOfTwo } from './exploreContentItemContentOneOfEngagementAllOfTwo';

export type ExploreContentItemContentOneOfEngagement = ExploreContentItemContentOneOfEngagementAllOf & ExploreContentItemContentOneOfEngagementAllOfTwo;
